import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import TextField from '@mui/material/TextField';

// ----------------------------------------------------------------------

export default function RHFTextField({ name, helperText, type, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          sx={{
            input: {
              textAlign: type === 'number' ? 'right' : 'left',
              borderColor: error ? '#ff6543' : '',
            },
          }}
          type={type}
          value={type === 'number' && field.value === 0 ? '' : field.value}
          onChange={(event) => {
            if (type === 'number') {
              field.onChange(Number(event.target.value));
            } else {
              // 1. Remove all spaces at the very beginning (covers "only spaces" too)
              // 2. Replace any instance of 2 or more spaces with a single space
              const formattedValue = event.target.value
                .replace(/^\s+/g, '')
                .replace(/\s{2,}/g, ' ');

              field.onChange(formattedValue);
            }
          }}
          onBlur={(event) => {
            if (type !== 'number' && typeof event.target.value === 'string') {
              // Trim any leftover space at the very end when the user clicks away
              field.onChange(event.target.value.trim());
            }
            // Trigger react-hook-form's default onBlur for touched state
            field.onBlur();
          }}
          error={!!error}
          helperText={error ? error?.message : helperText}
          {...other}
        />
      )}
    />
  );
}

RHFTextField.propTypes = {
  helperText: PropTypes.any,
  name: PropTypes.string,
  type: PropTypes.string,
};
